// import React, { useState } from "react";
// // import Header from "./Header";
// import { Alert } from "./Alert";

// import axios from "axios";
// import call from "../Call_Icon.png";
// import { Link } from "react-router-dom";

// import Hide_pass from "../hide_pass.png";
// import Open_pass from "../show_pass.png";
// import logo from "../assets/Icon/insurance_white.png";

// const Signup2 = () => {
//   const [alertVisible, setAlertVisible] = useState(false);
//   const [alertType, setAlertType] = useState("");
//   const [alertMessage, setAlertMessage] = useState("");
//   const [alertTitle, setAlertTitle] = useState("");
//   const [password, setPassword] = useState("");

//   const [showPassword, setShowPassword] = useState(false);

//   const togglePasswordVisibility = () => {
//     setShowPassword(!showPassword);
//   };

//   const [Email_valid, setEmail_valid] = useState(true);

//   const [Mob_valid, setMob_valid] = useState(true);

//   const [Name_valid, setName_valid] = useState(true);
//   const [Pan_valid, setPan_valid] = useState(true);
//   const [Pass_valid, setPass_valid] = useState(true);

//   const handlePasswordChange = (e) => {
//     setPassword(e.target.value);
//   };

//   const validStyle = {
//     border: "2px solid #E5E7E8",
//   };
//   const notValidStyle = {
//     border: "1px solid red",
//   };

//   const [name, setName] = useState("");
//   const [email, setEmail] = useState("");
//   const [mobile, setMob] = useState("");
//   const [pan, setPan] = useState("");

//   const validPAN = (e) => {
//     let panRegex = new RegExp(/^([A-Z]){5}([0-9]){4}([A-Z]){1}?$/);
//     let panNumber = e.target.value.trim().toUpperCase();

//     if (panRegex.test(panNumber)) {
//       setPan(panNumber);
//       setPan_valid(true);
//       return "true";
//     } else {
//       setPan("");
//       setPan_valid(false);
//       return "false";
//     }
//   };

//   const validMob = (e) => {
//     let regex = new RegExp(/(0|91)?[6-9][0-9]{9}/);
//     let mobile_number = e.target.value;
//     // if mobile_number is empty return false
//     if (mobile_number == null) {
//       console.log("mobile not valid");
//       setMob("");
//       setMob_valid(false);
//       return "false";
//     }

//     // Return true if the mobile_number matched the ReGex
//     if (regex.test(mobile_number) == true) {
//       setMob(e.target.value);
//       setMob_valid(true);

//       return "true";
//     } else {
//       setMob("");
//       setMob_valid(false);
//       return "false";
//     }
//   };
//   const validEmail = (e) => {
//     var validRegex =
//       /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
//     if (e.target.value.match(validRegex)) {
//       setEmail_valid(true);
//       setEmail(e.target.value);
//       console.log("valid");
//     } else {
//       setEmail_valid(false);
//       console.log("not valid");
//       setEmail("");
//     }
//   };
//   const handleSignUp = async (e) => {
//     e.preventDefault();
//     try {
//       console.log(password);
//       let res = await axios.post("http://3.110.120.207/signup", {
//         name,
//         email,
//         mobile: mobile,
//         password,
//       });
//       let data = res.data;

//       if (data.Status === "Ok") {
//         document.getElementById("name").value = "";
//         document.getElementById("email").value = "";
//         document.getElementById("mobile").value = "";

//         setAlertType("success");
//         setAlertMessage(data.msg);
//         setAlertVisible(true);
//         setAlertTitle("Success!");
//         setTimeout(() => {
//           setAlertVisible(false);
//         }, 2000);
//         window.location.href = "/login";
//       } else {
//         // alert(data.msg)
//         setAlertType("error");
//         setAlertMessage(data.msg);
//         setAlertVisible(true);
//         setAlertTitle("Error:");
//         setTimeout(() => {
//           setAlertVisible(false);
//         }, 5000);
//       }
//     } catch (e) {}
//   };

//   const validName = (e) => {
//     const inputValue = e.target.value;
//     setName(inputValue);

//     const nameParts = inputValue.split(" ");
//     if (nameParts.length >= 2 && nameParts[1].length >= 1) {
//       setName_valid(true);
//     } else {
//       setName_valid(false);
//     }
//   };

//   const validatePassword = (e) => {
//     const passValue = e.target.value;
//     setPassword(passValue);

//     // Check if the password is at least 8 characters long
//     const isLengthValid = password.length >= 8;

//     // Check if the password contains at least one lowercase letter
//     const hasLowercase = /[a-z]/.test(password);

//     // Check if the password contains at least one uppercase letter
//     const hasUppercase = /[A-Z]/.test(password);

//     // Check if the password contains at least one number
//     const hasNumber = /\d/.test(password);

//     // Set the overall validity based on all criteria
//     const isValidPassword =
//       isLengthValid && hasLowercase && hasUppercase && hasNumber;

//     setPass_valid(isValidPassword);
//     console.log(Pass_valid);
//     console.log(password);
//   };

//   return (
//     <div className="bg-gradient-to-r from-teal-500 via-blue-500 to-indigo-500 h-[300px] ">
//       <div className="h-screen ">
//         {/* <Header /> */}

//         <div className="flex w-[100%]   justify-center py-10 items-center m-[auto] relative">
//           <div className="absolute top-[15%]  left-1/2 transform -translate-x-1/2 -translate-y-1/2  ">
//             <img
//               src={logo}
//               alt="Logo"
//               className="2xl:w-[240] 2xl:h-[70px] w-[180] h-[50px]"
//             />
//           </div>
//           <form className="bg-white p-10 pb-[25px] sm:p-15  rounded-md shadow-lg shadow-blue-500/50 2xl:w-[30%] 2xl:mt-[150px]  mt-[100px]">
//             <h1 className="text-gray-800 font-bold text-[20px] mb-5">
//               Join Analah Insurance and begin your PoSP journey!
//             </h1>
//             {/* <p className="text-sm font-normal text-gray-600 mb-7">Welcome Join Analah Insurance and begin your PoSP journey!</p> */}
//             <div
//               className="flex items-center border-2 py-2 px-3 rounded-2xl mb-4"
//               style={Name_valid ? validStyle : notValidStyle}
//             >
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="h-5 w-5 text-gray-400"
//                 viewBox="0 0 20 20"
//                 fill="currentColor"
//               >
//                 <path
//                   fillRule="evenodd"
//                   d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
//                   clipRule="evenodd"
//                 />
//               </svg>
//               <input
//                 onChange={(e) => validName(e)}
//                 className="pl-2 outline-none border-none w-[100%]"
//                 type="text"
//                 name="name"
//                 id="name"
//                 placeholder="Full Name"
//                 autoFocus={true}
//               />
//             </div>

//             <div
//               className="flex items-center border-2 py-2 px-3 rounded-2xl mb-4"
//               style={Email_valid ? validStyle : notValidStyle}
//             >
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="h-5 w-5 text-gray-400"
//                 fill="none"
//                 viewBox="0 0 24 24"
//                 stroke="currentColor"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth="2"
//                   d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
//                 />
//               </svg>
//               <input
//                 onChange={(e) => validEmail(e)}
//                 className="pl-2 outline-none border-none w-[100%]"
//                 type="email"
//                 name="email"
//                 id="email"
//                 placeholder="Email Address"
//               />
//             </div>

//             {/* ----------------------  PAN Card ----------------------------------  */}
//             {/* <div
//             className="flex items-center border-2 py-2 px-3 rounded-2xl mb-4"
//             style={Email_valid ? validStyle : notValidStyle}
//           >
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               className="h-5 w-5 text-gray-400"
//               fill="none"
//               viewBox="0 0 24 24"
//               stroke="currentColor"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth="2"
//                 d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
//               />
//             </svg>

//             <input
//               onChange={(e) => validPAN(e)}
//               className="pl-2 outline-none border-none w-[100%]"
//               type="text"
//               name="pan"
//               id="pan"
//               placeholder="PAN No."
//             />

//           </div> */}

//             {/* <div
//             className="flex items-center border-2 py-2 px-3 rounded-2xl mb-4"
//             style={Mob_valid ? validStyle : notValidStyle}
//           >
//             <img src={call} alt="call_icon" className="w-[15px] h-[15px]" />
//             <input
//               onChange={(e) => validMob(e)}
//               className="pl-2 outline-none border-none w-[100%]"
//               type="number"
//               name="mobile"
//               id="mobile"
//               placeholder="Mobile Number"
//             />
//           </div> */}

//             <div
//               className="flex items-center border-2 py-2 px-3 rounded-2xl mb-4"
//               style={Pass_valid ? validStyle : notValidStyle}
//             >
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="h-5 w-5 text-gray-400"
//                 fill="none"
//                 viewBox="0 0 24 24"
//                 stroke="currentColor"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth="2"
//                   d="M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4"
//                 />
//               </svg>

//               <input
//                 onChange={(e) => validatePassword(e)}
//                 className="pl-2 outline-none border-none w-[100%]"
//                 type={showPassword ? "text" : "password"}
//                 name="password"
//                 id="password"
//                 placeholder="Password"
//               />

//               <div className="eye-icon" onClick={togglePasswordVisibility}>
//                 {showPassword ? (
//                   <img
//                     src={Open_pass}
//                     alt="open"
//                     className="w-[15px] h-[15px]"
//                   />
//                 ) : (
//                   <>
//                     <img
//                       src={Hide_pass}
//                       alt="close"
//                       className="w-[15px] h-[15px]"
//                     />
//                   </>
//                 )}
//               </div>

//               {/* <input type="password" value={password} onChange={validatePassword} /> */}
//             </div>

//             <button
//               onClick={(e) => handleSignUp(e)}
//               className="block w-full bg-blue-600 mt-4 py-2 rounded-2xl text-white font-semibold mb-2"
//               disabled={
//                 !Email_valid ||
//                 !Name_valid ||
//                 !name ||
//                 !email ||
//                 !Pass_valid ||
//                 !password
//               }
//             >
//               Sign Up
//             </button>

//             <div className="flex justify-between text-sm font-normal text-gray-600 mt-[20px] ">
//               <p className="text-[14px] mt-[12px]">Already registered?</p>

//               <button className="hover:text-blue-500 underline">
//                 <Link to="/login">Log In</Link>
//               </button>
//             </div>
//           </form>

//           {alertVisible && (
//             <Alert type={alertType} message={alertMessage} title={alertTitle} />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Signup2;
import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { Link } from "react-router-dom";
import Hide_pass from "../hide_pass.png";
import Open_pass from "../show_pass.png";
import logo from "../assets/Icon/insurance_white.png";
import { Alert } from "./Alert";
import { BASE_URL } from "../baseurl";

// Prefix options
const prefixes = [
  { value: "Mr", label: "Mr" },
  { value: "Ms", label: "Ms" },
  { value: "Mrs", label: "Mrs" },
  { value: "Dr", label: "Dr" },
];

const Signup2 = () => {
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertMessage, setAlertMessage] = useState({
    type: "",
    msg: "",
    title: "",
  });

  const validStyle = "border-[#E5E7E8]";
  const notValidStyle = "border-red-400";

  const formik = useFormik({
    initialValues: {
      prefix: "Mr",
      firstName: "",
      middleName: "",
      lastName: "",
      email: "",
      mobile: "",
      password: "",
      reference: ""
    },
    validationSchema: Yup.object({
      prefix: Yup.string().required("Prefix is required"),
      firstName: Yup.string().required("First name is required"),
      middleName: Yup.string(), // Optional field
      lastName: Yup.string().required("Last name is required"),
      email: Yup.string().email("Invalid email address").required("Required"),
      mobile: Yup.string()
        .matches(/^[0-9]{10}$/, "Invalid mobile number")
        .required("Required"),
      password: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
          "Password must contain at least one uppercase letter, one lowercase letter, and one number"
        )
        .required("Required"),
    }),
    onSubmit: async (values, { setSubmitting, setFieldError }) => {
      try {
        // Combine the name fields into a single name field for the API
        const fullName = `${values.firstName} ${values.middleName} ${values.lastName}`.replace(/\s+/g, ' ').trim();
        
        const submitData = {
          prefix: values.prefix,
          name: fullName,
          email: values.email,
          mobile: values.mobile,
          password: values.password,
          reference:  values.reference,
        };

        if(!submitData?.reference){
          delete submitData?.reference
        }

        let res = await axios.post(`${BASE_URL}/user/auth/register`, submitData);
        let data = res.data;

        if (res.status === 200) {
          formik.resetForm();
          setAlertVisible(true);
          setAlertMessage({
            type: "success",
            msg: data.msg,
            title: "Success!",
          });
          setTimeout(() => {
            setAlertVisible(false);
          }, 2000);
          window.location.href = "/login";
        } else {
          setAlertVisible(true);
          setAlertMessage({
            type: "error",
            msg: data.msg,
            title: "Error",
          });
          setTimeout(() => {
            setAlertVisible(false);
          }, 5000);
        }
      } catch (error) {
        console.error("Error:", error);
        setAlertVisible(true);
        setAlertMessage({
          type: "error",
          msg: error?.response?.data?.msg,
          title: "Error",
        });
        setTimeout(() => {
          setAlertVisible(false);
        }, 5000);
      }
      setSubmitting(false);
    },
  });

  const [showPassword, setShowPassword] = React.useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="bg-gradient-to-r from-teal-500 via-blue-500 to-indigo-500 h-[300px] ">
      <div className="h-screen ">
        <div className="flex w-[100%] justify-center py-10 items-center m-[auto] relative">
          <div className="absolute top-[15%] left-1/2 transform -translate-x-1/2 -translate-y-1/2  ">
            <img
              src={logo}
              alt="Logo"
              className="2xl:w-[240] 2xl:h-[70px] w-[180] h-[50px]"
            />
          </div>
          <form
            onSubmit={formik.handleSubmit}
            className="bg-white p-10 pb-[25px] sm:p-15 rounded-md shadow-lg shadow-blue-500/50 2xl:w-[30%] 2xl:mt-[150px]  mt-[100px]"
          >
            <h1 className="text-gray-800 font-bold text-[20px] mb-5">
              Join Analah Insurance and begin your PoSP journey!
            </h1>

            {/* Prefix Dropdown */}
            <div
              className={`flex items-center border py-2 px-3 rounded-2xl mb-4 ${
                formik.touched.prefix && formik.errors.prefix
                  ? notValidStyle
                  : validStyle
              }`}
            >
              <select
                name="prefix"
                id="prefix"
                value={formik.values.prefix}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="pl-2 outline-none border-none w-[100%]"
              >
                {prefixes.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
            {formik.touched.prefix && formik.errors.prefix && (
              <div className="text-red-500 text-sm mb-2 ml-3">
                {formik.errors.prefix}
              </div>
            )}
            
            {/* First Name */}
            <div
              className={`flex items-center border py-2 px-3 rounded-2xl mb-4 ${
                formik.touched.firstName && formik.errors.firstName
                  ? notValidStyle
                  : validStyle
              }`}
            >
              <input
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.firstName}
                className="pl-2 outline-none border-none w-[100%]"
                type="text"
                name="firstName"
                id="firstName"
                placeholder="First Name *"
                autoFocus={true}
              />
            </div>
            {formik.touched.firstName && formik.errors.firstName && (
              <div className="text-red-500 text-sm mb-2 ml-3">
                {formik.errors.firstName}
              </div>
            )}

            {/* Middle Name */}
            <div
              className={`flex items-center border py-2 px-3 rounded-2xl mb-4 ${
                formik.touched.middleName && formik.errors.middleName
                  ? notValidStyle
                  : validStyle
              }`}
            >
              <input
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.middleName}
                className="pl-2 outline-none border-none w-[100%]"
                type="text"
                name="middleName"
                id="middleName"
                placeholder="Middle Name (Optional)"
              />
            </div>

            {/* Last Name */}
            <div
              className={`flex items-center border py-2 px-3 rounded-2xl mb-4 ${
                formik.touched.lastName && formik.errors.lastName
                  ? notValidStyle
                  : validStyle
              }`}
            >
              <input
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.lastName}
                className="pl-2 outline-none border-none w-[100%]"
                type="text"
                name="lastName"
                id="lastName"
                placeholder="Last Name *"
              />
            </div>
            {formik.touched.lastName && formik.errors.lastName && (
              <div className="text-red-500 text-sm mb-2 ml-3">
                {formik.errors.lastName}
              </div>
            )}

            {/* Email */}
            <div
              className={`flex items-center border py-2 px-3 rounded-2xl mb-4 ${
                formik.touched.email && formik.errors.email
                  ? notValidStyle
                  : validStyle
              }`}
            >
              <input
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
                className="pl-2 outline-none border-none w-[100%]"
                type="email"
                name="email"
                id="email"
                placeholder="Email Address"
              />
            </div>
            {formik.touched.email && formik.errors.email && (
              <div className="text-red-500 text-sm mb-2 ml-3">
                {formik.errors.email}
              </div>
            )}

            {/* Mobile */}
            <div
              className={`flex items-center border py-2 px-3 rounded-2xl mb-4 ${
                formik.touched.mobile && formik.errors.mobile
                  ? notValidStyle
                  : validStyle
              }`}
            >
              <input
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.mobile}
                className="pl-2 outline-none border-none w-[100%]"
                type="text"
                name="mobile"
                id="mobile"
                placeholder="Mobile Number"
              />
            </div>
            {formik.touched.mobile && formik.errors.mobile && (
              <div className="text-red-500 text-sm mb-2 ml-3">
                {formik.errors.mobile}
              </div>
            )}

            {/* Password */}
            <div
              className={`flex items-center border py-2 px-3 rounded-2xl mb-4 ${
                formik.touched.password && formik.errors.password
                  ? notValidStyle
                  : validStyle
              }`}
            >
              <input
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
                className="pl-2 outline-none border-none w-[100%]"
                type={showPassword ? "text" : "password"}
                name="password"
                id="password"
                placeholder="Password"
              />
              <div className="eye-icon" onClick={togglePasswordVisibility}>
                {showPassword ? (
                  <img
                    src={Open_pass}
                    alt="open"
                    className="w-[15px] h-[15px]"
                  />
                ) : (
                  <img
                    src={Hide_pass}
                    alt="close"
                    className="w-[15px] h-[15px]"
                  />
                )}
              </div>
            </div>
            {formik.touched.password && formik.errors.password && (
              <div className="text-red-500 text-sm mb-2 ml-3">
                {formik.errors.password}
              </div>
            )}

            {/* Reference */}
            <div
              className={`flex items-center border py-2 px-3 rounded-2xl mb-4 `}
            >
              <input
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.reference}
                className="pl-2 outline-none border-none w-[100%]"
                type="text"
                name="reference"
                id="reference"
                placeholder="Reference"
              />
            </div>

            <button
              type="submit"
              className="block w-full bg-blue-600 mt-4 py-2 rounded-2xl text-white font-semibold mb-2 disabled:opacity-50"
              disabled={formik.isSubmitting || !formik.isValid}
            >
              {formik.isSubmitting ? "Signing Up..." : "Sign Up"}
            </button>

            <div className="flex justify-between text-sm font-normal text-gray-600 mt-[20px] ">
              <p className="text-[14px] mt-[12px]">Already registered?</p>

              <button className="hover:text-blue-500 underline focus:outline-none">
                <Link to="/login">Login</Link>
              </button>
            </div>
          </form>
          {alertVisible && <Alert data={alertMessage} />}
        </div>
      </div>
    </div>
  );
};

export default Signup2;
